import React from 'react';
import { PROCEDURE_IDS } from '@zocdoc-frontend-common/utils-constants';
import { MODAL_STRINGS } from './constants';
import { ErrorModalDescription } from './ErrorModalDescription';
import { SyncErrorModalDescription } from './SyncErrorModalDescription';

export const genericErrorModalContent = (handlePrimaryButtonClick) => ({
    headerText: MODAL_STRINGS.OopsSomethingWentWrong,
    descriptionText: <ErrorModalDescription />,
    primaryButtonText: MODAL_STRINGS.Ok,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    gaAction: 'Show Booking Submit Error Modal',
    trackingMessage: MODAL_STRINGS.OopsSomethingWentWrong,
});

export const customErrorModalContent = (
    handlePrimaryButtonClick,
    descriptionText
) => ({
    headerText: descriptionText,
    primaryButtonText: MODAL_STRINGS.Ok,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    gaAction: 'Show Booking Submit Error Modal',
    trackingMessage: descriptionText,
});

export const syncFailureModalContent = (
    handlePrimaryButtonClick,
    phoneNumber
) => ({
    headerText: MODAL_STRINGS.OopsWereUnableToBook,
    descriptionText: <SyncErrorModalDescription phoneNumber={phoneNumber} />,
    primaryButtonText: MODAL_STRINGS.GoToHomePage,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    gaAction: MODAL_STRINGS.OopsWereUnableToBook,
});

export const appointmentTimeErrorModalContent = (handlePrimaryButtonClick) => ({
    headerText: MODAL_STRINGS.OopsAppointmentNoLongerAvailable,
    descriptionText: MODAL_STRINGS.PleaseSelectANewTime,
    primaryButtonText: MODAL_STRINGS.SelectANewTime,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    gaAction: MODAL_STRINGS.OopsAppointmentNoLongerAvailable,
});

export const patientTimesOverlapErrorModalContent = (
    handlePrimaryButtonClick
) => ({
    headerText: MODAL_STRINGS.PatientTimesOverlap,
    primaryButtonText: MODAL_STRINGS.Ok,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    gaAction: 'Show Booking Submit Error Modal',
    trackingMessage: MODAL_STRINGS.PatientTimesOverlap,
});

export const phoneIsVerifiedFailureErrorModalContent = (
    handlePrimaryButtonClick
) => ({
    headerText: MODAL_STRINGS.PhoneIsVerifiedFailure,
    primaryButtonText: MODAL_STRINGS.Ok,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    gaAction: 'Show Booking Submit Error Modal',
    trackingMessage: MODAL_STRINGS.PhoneIsVerifiedFailure,
});

export const didYouStepAwayModalContent = (handlePrimaryButtonClick) => ({
    headerText: MODAL_STRINGS.OopsItLooksLikeYouSteppedAway,
    descriptionText: MODAL_STRINGS.WeClearedYourInformation,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    gaAction: MODAL_STRINGS.OopsItLooksLikeYouSteppedAway,
});

export const appointmentAlreadySubmittedModalContent = ({
    handlePrimaryButtonClick,
    handleSecondaryButtonClick,
}) => ({
    headerText: MODAL_STRINGS.OopsAppointmentAlreadySubmitted,
    descriptionText: MODAL_STRINGS.HeadOverToAccountsPage,
    primaryButtonText: MODAL_STRINGS.MyAccounts,
    secondaryButtonText: MODAL_STRINGS.NeverMind,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    onClickSecondaryButton: () => handleSecondaryButtonClick(),
    gaAction: MODAL_STRINGS.OopsAppointmentAlreadySubmitted,
});

export const maxAppointmentsReachedModalContent = (
    handlePrimaryButtonClick,
    handleSecondaryButtonClick
) => ({
    headerText: MODAL_STRINGS.Sorry,
    descriptionText: (
        <div>
            {MODAL_STRINGS.YouveReachedMaximumAppointments1}
            <br />
            {MODAL_STRINGS.YouveReachedMaximumAppointments2}
            <br />
            {MODAL_STRINGS.YouveReachedMaximumAppointments3}
        </div>
    ),
    primaryButtonText: MODAL_STRINGS.ViewMyUpcomingAppointments,
    secondaryButtonText: MODAL_STRINGS.Close,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    onClickSecondaryButton: () => handleSecondaryButtonClick(),
});

export const maxVaccineAppointmentsReachedModalContent = (
    handlePrimaryButtonClick,
    handleSecondaryButtonClick,
    procedureId
) => {
    const headerText =
        procedureId === PROCEDURE_IDS.COVID_19_VACCINE_DOSE_1
            ? MODAL_STRINGS.MaximumVaccineAppointmentHeaderDose1
            : procedureId === PROCEDURE_IDS.COVID_19_VACCINE_DOSE_2
            ? MODAL_STRINGS.MaximumVaccineAppointmentHeaderDose2
            : MODAL_STRINGS.MaximumVaccineAppointmentHeaderBooster;

    return {
        headerText,
        descriptionText: (
            <div>{MODAL_STRINGS.MaximumVaccineAppointmentBody}</div>
        ),
        primaryButtonText: MODAL_STRINGS.ViewMyUpcomingAppointments,
        secondaryButtonText: MODAL_STRINGS.Close,
        onClickPrimaryButton: () => handlePrimaryButtonClick(),
        onClickSecondaryButton: () => handleSecondaryButtonClick(),
    };
};
